import { toast } from "react-toastify";
import axios from "axios";
import { BACKEND } from "../../config/configEnvs";
import {
  debeGenerarInstancia,
  getFechaPagoExactaFromPlantilla,
} from "../fechaPagoRecurrente";

const GenerarInstanciasPagosRecurrentes = async (mes, año, onSuccess) => {
  const month = Number(mes);
  const year = Number(año);

  if (!month || !year) {
    toast.error("Selecciona mes y año");
    return;
  }

  const confirmed = window.confirm(
    `¿Generar instancias de pagos recurrentes para ${month}/${year}? Solo se crearán las que no existan.`
  );
  if (!confirmed) return;

  const toastId = toast.loading("Generando instancias...");

  try {
    const activosRes = await axios.get(
      `${BACKEND}/api/pagosRecurrentes?limit=0&where[activo][equals]=true`,
      { withCredentials: true }
    );
    const activos = activosRes.data.docs || [];

    if (activos.length === 0) {
      toast.update(toastId, {
        render: "No hay pagos recurrentes activos",
        type: "info",
        isLoading: false,
        autoClose: 3000,
      });
      return;
    }

    const existingRes = await axios.get(
      `${BACKEND}/api/instanciasPagoRecurrente?limit=0&where[month][equals]=${month}&where[year][equals]=${year}&depth=0`,
      { withCredentials: true }
    );
    const existing = existingRes.data.docs || [];
    const existingIds = new Set(
      existing.map((i) =>
        typeof i.pagoRecurrente === "object"
          ? i.pagoRecurrente.id
          : i.pagoRecurrente
      )
    );

    const aplicables = activos.filter((p) => debeGenerarInstancia(p, month));
    const pendientes = aplicables.filter((p) => !existingIds.has(p.id));
    let created = 0;

    for (const pago of pendientes) {
      await axios.post(
        `${BACKEND}/api/instanciasPagoRecurrente`,
        {
          pagoRecurrente: pago.id,
          month,
          year,
          montoReal: pago.montoEstimado ?? 0,
          estadoPago: "Pendiente",
          fechaPagoExacta: getFechaPagoExactaFromPlantilla(year, month, pago),
        },
        { withCredentials: true }
      );
      created += 1;
    }

    const skipped = aplicables.length - created;
    const omitidosPorFrecuencia = activos.length - aplicables.length;

    const omitidosMsg =
      omitidosPorFrecuencia > 0
        ? `, ${omitidosPorFrecuencia} no aplican este mes`
        : "";

    toast.update(toastId, {
      render: `Listo: ${created} creadas, ${skipped} ya existían${omitidosMsg}`,
      type: "success",
      isLoading: false,
      autoClose: 4000,
    });

    if (onSuccess) onSuccess();
  } catch (error) {
    console.error("Error al generar instancias:", error);
    toast.update(toastId, {
      render: error.response?.data?.errors?.[0]?.message || "Error al generar instancias",
      type: "error",
      isLoading: false,
      autoClose: 4000,
    });
  }
};

export default GenerarInstanciasPagosRecurrentes;
